<mat-card class="sitemapContainer">
  <mat-card-title>Site Map</mat-card-title>

  <h3 style="margin-top: 12px;">📦 Products</h3>
  <div class="table-container" *ngIf="dataSource">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <!-- Product id Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Product ID </th>
        <td mat-cell *matCellDef="let element"> {{ element.id }} </td>
      </ng-container>

      <!-- Product Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Name </th>
        <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
      </ng-container>

      <!-- URL Column -->
      <ng-container matColumnDef="url">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> URL </th>
        <td mat-cell *matCellDef="let element">
          <a [href]="element.url" target="_blank">{{ element.url }}</a>
        </td>
      </ng-container>

      <!-- Header & Row Declarations -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
  </div>
</mat-card>